export enum PosConfigurationGroupEnum {
  discount = 'Discount',
  serviceCharge = 'ServiceCharge',
  payments = 'Payments',
  checkout = 'Checkout',
  functions = 'Functions',
  security = 'Security',
  defaultScreen = 'DefaultScreen',
  printer = 'Printer'
 }
